import gql from 'graphql-tag';

export const paycheckPeriodFragments = gql`
  fragment paycheckPeriodFragments on PaycheckPeriod {
    id
    name
    startDate
    endDate
    journalDate
    bookkeepingPeriod
    isLocked
  }
`;

export const paycheckPeriodForPaycheckListFragments = gql`
  fragment paycheckPeriodForPaycheckListFragments on PaycheckPeriod {
    id
    paycheckCount
  }
`;

export const ALL_PAYCHECK_PERIODS = gql`
  query currentUnitPaycheckPeriods {
    currentUnit {
      id
      paycheckPeriods {
        ...paycheckPeriodFragments
      }
    }
  }
  ${paycheckPeriodFragments}
`;

export const ALL_PAYCHECK_PERIODS_FOR_PAYCHECK_LIST = gql`
  query currentUnitPaycheckPeriodsForPaycheckList {
    currentUnit {
      id
      paycheckPeriods {
        ...paycheckPeriodFragments
        ...paycheckPeriodForPaycheckListFragments
      }
    }
  }
  ${paycheckPeriodFragments}
  ${paycheckPeriodForPaycheckListFragments}
`;
